import { jsx as _jsx } from "react/jsx-runtime";
import { useAppSelector } from '../hooks';
import { DeviceButtonsZigbee } from '../components/DeviceButtonsZigbee';
import { DeviceButtonsNexaOnOff } from '../components/DeviceButtonsNexaOnOff';
import { DeviceButtonsNexaDim } from '../components/DeviceButtonsNexaDim';
import { DeviceButtonsHasta } from '../components/DeviceButtonsHasta';
import { DeviceButtonsGaragePort } from './DeviceButtonGaragePort';
export const DeviceButtons = (props) => {
    const devices = useAppSelector(state => state.definitions.devices);
    const device = devices[props.device_id];
    if (device == undefined) {
        return null;
    }
    if (device.transmitter_kind == 'rollershade') {
        return _jsx(DeviceButtonsHasta, { device_id: props.device_id });
    }
    else if (device.transmitter_kind == 'dim') {
        return _jsx(DeviceButtonsNexaDim, { device_id: props.device_id });
    }
    else if (device.transmitter_kind == 'onoff' && device.protocol.name == 'zigbee') {
        return _jsx(DeviceButtonsZigbee, { node_id: device.protocol.zigbee_node_id, endpoint_id: device.protocol.endpoint_id });
    }
    else if (device.transmitter_kind == 'onoff') {
        return _jsx(DeviceButtonsNexaOnOff, { device_id: props.device_id });
    }
    else if (device.transmitter_kind == 'garage' && device.protocol.name == 'zigbee tuya garage') {
        return _jsx(DeviceButtonsGaragePort, { node_id: device.protocol.zigbee_node_id, endpoint_id: device.protocol.endpoint_id });
    }
    else {
        console.log('Invalid DeviceButtons kind ' + device.transmitter_kind);
        return null;
    }
};
